<template>
  <fin-work-in-progess-page title="Vergleiche ETFs"/>
</template>

<script>
import FinWorkInProgessPage from "@/components/common/WorkInProgressPage"

export default {
  name: "FinCompareETF",
  components: {FinWorkInProgessPage}
}
</script>

<style scoped>

</style>
